<div class="toggle-button-view">
  <h2>Toggle Button View</h2>

  <form [formGroup]="form">
    <h3>Основные примеры</h3>
    <div class="toggle-buttons-list">
      <pa-toggle-button
        *ngFor="let button of toggleButtons"
        [formControlName]="button.controlName"
        [onLabel]="button.label"
        [count]="button.count"
        [severity]="button.severity">
      </pa-toggle-button>
    </div>

  </form>
</div>

